/**
 * Thin re-export of the REAL, proven browser passkey helpers, vendored as
 * browser ESM under ../../../vendor by prepare-crypto.sh. We do NOT
 * reimplement WebAuthn or X25519 keygen — this is the exact code the
 * backend integration tests exercise. The rest of the member app imports
 * from here (and unit tests vi.mock THIS module, so they never need the
 * vendor build to exist).
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import { enrollPasskey, authenticateWithPasskey } from '../../../vendor/client/auth/passkey.js';
import type { SessionTokens } from './session';

export interface EnrollResult {
  credentialId: string;
  hpkePublicKey: string;
  publicKeyBound: true;
}

export interface AuthenticateResult {
  verified: boolean;
  userId: string;
  /**
   * Issued by the server INSIDE the verified WebAuthn ceremony
   * (`WebAuthnController.authenticationVerify` → `SessionService`). There is
   * no separate bare-userId session route to call afterward.
   */
  tokens: SessionTokens;
}

export function enroll(
  email: string,
  deviceLabel?: string,
  enrollmentTicket?: string,
): Promise<EnrollResult> {
  return enrollPasskey({ email, deviceLabel, enrollmentTicket }) as Promise<EnrollResult>;
}

export function authenticate(email: string): Promise<AuthenticateResult> {
  return authenticateWithPasskey({ email }) as Promise<AuthenticateResult>;
}
